import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useFeatureFlag } from '../../../helpers/feature-flags/feature-flags.hooks';
import { FeatureFlag } from '../../../helpers/feature-flags/feature-flags.type';
import { useFinancialsStore } from '../../../store/financials-store/financials-store';
import { setChart } from '../../../store/financials-store/financials-store.actions';
import { Charts as ViewableCharts } from '../../../store/financials-store/financials-store.type';
import { newCOLORS } from '../../../styles/colors';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';

function Tabs() {
  const { t } = useTranslation();
  const selectedChart = useFinancialsStore((state) => state.chart);
  const isAgenticProcessEnabled = useFeatureFlag(FeatureFlag.AgenticProcessByHooks);
  return (
    <Group>
      <ChartButton
        label={t('financials.charts.cost_vs_output')}
        iconName="calendar_month"
        onClick={() => setChart(ViewableCharts.CostVersusOutput)}
        selected={selectedChart === ViewableCharts.CostVersusOutput}
      />
      <ChartButton
        label={t('financials.charts.allocation_of_costs')}
        iconName="payments"
        onClick={() => setChart(ViewableCharts.AllocationOfCosts)}
        selected={selectedChart === ViewableCharts.AllocationOfCosts}
      />
      <ChartButton
        label={t('financials.charts.cost_by_initiative')}
        iconName="task_alt"
        onClick={() => setChart(ViewableCharts.CostByInitiative)}
        selected={selectedChart === ViewableCharts.CostByInitiative}
      />
      {isAgenticProcessEnabled && (
        <ChartButton
          label="Agent Costs"
          iconName="smart_toy"
          onClick={() => setChart(ViewableCharts.AgentCosts)}
          selected={selectedChart === ViewableCharts.AgentCosts}
        />
      )}
    </Group>
  );
}

function ChartButton({
  label,
  iconName,
  onClick,
  selected,
}: {
  label: string;
  iconName: string;
  onClick: () => void;
  selected: boolean;
}) {
  return (
    <Button
      variant={selected ? 'secondary' : 'outline'}
      radius="xl"
      size="xs"
      leftSection={
        <Icon
          name={iconName}
          color={selected ? newCOLORS.white : newCOLORS.gray}
          size={14}
          style={{ cursor: 'pointer' }}
        />
      }
      onClick={onClick}
    >
      {label}
    </Button>
  );
}

export { Tabs };
